import { render, staticRenderFns } from "./SafetyPreventionRequest.vue?vue&type=template&id=a917d890&scoped=true"
import script from "./SafetyPreventionRequest.vue?vue&type=script&lang=js"
export * from "./SafetyPreventionRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a917d890",
  null
  
)

export default component.exports